/* CuddleBuds Rewards — Shopify storefront controller. */
(function () {
  "use strict";

   const rewards = [
  { threshold: 499, reward: "Free Delivery" },
    { threshold: 1299, reward: "Free Delivery + ₹100 off" },
    { threshold: 1799, reward: "Free delivery + ₹100 off + Mix Meat Bone Broth", detail: "(Free Gift)" }
  ];

  const GIFT_PRODUCT_HANDLE = "mix-meat-bone-broth-for-dogs-cats-gift";
  const GIFT_PROPERTY = "_cb_reward_gift";
  const GIFT_THRESHOLD = 1999;
  let giftVariantId;

  const panel = document.querySelector(".cb-rewards");
  const dialog = document.querySelector(".cb-rewards__dialog");
  const icon = document.querySelector("#cb-header-reward");
  let lastActiveElement;

  const money = value => new Intl.NumberFormat("en-IN", {
    style: "currency", currency: "INR", maximumFractionDigits: 0
  }).format(value);

  const rewardIcon = isEarned => isEarned
    ? '<svg class="cb-reward-icon cb-reward-icon--check" viewBox="0 0 24 24" aria-hidden="true"><path d="m8.3 12.2 2.3 2.3 5.1-5.1M12 2.8l2 1.6 2.6-.1.7 2.5 2.1 1.5-.8 2.5.8 2.5-2.1 1.5-.7 2.5-2.6-.1-2 1.6-2-1.6-2.6.1-.7-2.5-2.1-1.5.8-2.5-.8-2.5 2.1-1.5.7-2.5 2.6.1z"/></svg>'
    : '<svg class="cb-reward-icon cb-reward-icon--star" viewBox="0 0 24 24" aria-hidden="true"><path d="m12 3.1 2.55 5.16 5.7.83-4.13 4.02.98 5.68L12 16.12 6.9 18.8l.98-5.68-4.13-4.02 5.7-.83z"/></svg>';

  async function getCart() {
    const root = window.Shopify?.routes?.root || "/";
    const response = await fetch(`${root}cart.js`, {
      headers: { Accept: "application/json" }
    });
    if (!response.ok) throw new Error("Could not load cart");
    const cart = await response.json();
    return { total: cart.items_subtotal_price / 100, itemCount: cart.item_count, items: cart.items, items_subtotal_price: cart.items_subtotal_price };
  }

  function renderMilestones(container, cart, earned, next) {
    if (!container) return;
    container.innerHTML = rewards.map(reward => {
      const isEarned = cart.total >= reward.threshold;
      const state = isEarned ? "cb-milestone--earned" : reward === next ? "cb-milestone--next" : "";
      return `<article class="cb-milestone ${state}"><span class="cb-milestone__badge">${rewardIcon(isEarned)}</span><p class="cb-milestone__amount">${money(reward.threshold)}</p><p class="cb-milestone__reward">${reward.reward}${reward.detail ? `<br>${reward.detail}` : ""}</p></article>`;
    }).join("");
  }

  function renderCartMilestones(container, cart, earned, next) {
    if (!container) return;
    container.innerHTML = rewards.map(reward => {
      const isEarned = cart.total >= reward.threshold;
      const state = isEarned ? "cb-cart-rewards__milestone--earned" : reward === next ? "cb-cart-rewards__milestone--next" : "";
      return `<article class="cb-cart-rewards__milestone ${state}"><span class="cb-cart-rewards__badge">${rewardIcon(isEarned)}</span><p class="cb-cart-rewards__amount">${money(reward.threshold)}</p><p class="cb-cart-rewards__reward">${reward.reward}${reward.detail ? `<br>${reward.detail}` : ""}</p></article>`;
    }).join("");
  }

  function render(cart) {
    const earned = rewards.filter(reward => cart.total >= reward.threshold);
    const next = rewards.find((reward, index) => index > 0 && cart.total < reward.threshold);
    const progress = Math.min(100, (cart.total / rewards[rewards.length - 1].threshold) * 100);

    /* The icon is rendered on every page, but visible only when the cart has an item. */
    if (icon) {
      icon.hidden = cart.itemCount === 0;
      icon.setAttribute("aria-hidden", String(cart.itemCount === 0));
    }

    const popupFill = document.querySelector("[data-cb-progress-fill]");
    if (popupFill) {
      popupFill.style.width = `${progress}%`;
      popupFill.style.setProperty("--cb-popup-progress", `${progress}%`);
      popupFill.classList.toggle("cb-progress--complete", progress >= 100);
    }
    renderMilestones(document.querySelector("[data-cb-milestones]"), cart, earned, next);

    const popupMessage = document.querySelector("[data-cb-message]");
    if (popupMessage) popupMessage.textContent = next
      ? `${earned.length > 1 ? `${earned[earned.length - 1].reward} ${earned[earned.length - 1].detail || ""} unlocked.` : "Start earning rewards."} Add items worth ${money(next.threshold - cart.total)} more to get ${next.reward}!`
      : "Free delivery + ₹100 off bill + Bone Broth unlocked!";
    const popupSavings = document.querySelector("[data-cb-savings]");
    if (popupSavings) popupSavings.textContent = `🎉 ${earned.length > 1 ? `You've unlocked ${earned.length - 1} reward${earned.length > 2 ? "s" : ""}!` : "Your first reward is waiting!"}`;
    renderCartMeter(cart, earned, next, progress);
  }

  function renderCartMeter(cart, earned, next, progress) {
    document.querySelectorAll("[data-cb-cart-meter]").forEach(meter => {
      const meterFill = meter.querySelector("[data-cb-cart-meter-fill]");
      meterFill.style.setProperty("--cb-progress", `${progress}%`);
      meterFill.style.width = `${progress}%`;
      meterFill.classList.toggle("cb-progress--complete", progress >= 100);
      renderCartMilestones(meter.querySelector("[data-cb-cart-meter-milestones]"), cart, earned, next);
      const meterMessage = meter.querySelector("[data-cb-cart-meter-message]");
      if (meterMessage) meterMessage.textContent = next
        ? `${earned.length > 1 ? `${earned[earned.length - 1].reward} ${earned[earned.length - 1].detail || ""} unlocked.` : "Start earning rewards."} Add items worth ${money(next.threshold - cart.total)} more to get ${next.reward}!`
        : "Free delivery + ₹100 off bill + Bone Broth unlocked!";
      const meterSaving = meter.querySelector("[data-cb-cart-meter-saving]");
      if (meterSaving) meterSaving.textContent = earned.length > 1 ? `🎉 You've unlocked ${earned.length - 1} reward${earned.length > 2 ? "s" : ""}!` : "🎉 Your first reward is waiting!";
    });
  }

  async function findGiftVariantId() {
    if (giftVariantId) return giftVariantId;
    const root = window.Shopify?.routes?.root || "/";
    let response = await fetch(`${root}products/${GIFT_PRODUCT_HANDLE}.js`, { headers: { Accept: "application/json" } });
    let product = response.ok ? await response.json() : null;
    if (!product) {
      response = await fetch(`${root}products.json?limit=250`, { headers: { Accept: "application/json" } });
      if (!response.ok) return null;
      const catalog = await response.json();
      product = catalog.products.find(item => /mix\s*meat\s*bone\s*broth/i.test(item.title));
    }
    if (!product || !Array.isArray(product.variants)) {
      console.error("CB Rewards: gift product could not be found. Check the product handle and Online Store publication.", GIFT_PRODUCT_HANDLE);
      return null;
    }
    const variant = product.variants.find(item => /100\s*m?l/i.test(item.title) && item.available)
      || product.variants.find(item => /100\s*m?l/i.test(item.title))
      || product.variants.find(item => item.available)
      || product.variants[0];
    giftVariantId = variant ? variant.id : null;
    if (!giftVariantId) console.error("CB Rewards: gift product has no variants", product);
    return giftVariantId;
  }

  async function addGiftIfEligible(cart) {
    const root = window.Shopify?.routes?.root || "/";
    const giftLine = cart.items.find(item => item.properties && item.properties[GIFT_PROPERTY] === "true");
    const eligible = cart.items_subtotal_price / 100 >= GIFT_THRESHOLD;
    const variantId = eligible || giftLine ? await findGiftVariantId() : null;
    if (!variantId && !giftLine) return;
    if (eligible && !giftLine) {
      const response = await fetch(`${root}cart/add.js`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1, properties: { [GIFT_PROPERTY]: "true" } }] }) });
      if (!response.ok) {
        console.error("CB Rewards: Shopify rejected the gift variant", variantId, await response.text());
      } else if (window.location.pathname === "/cart") {
        /* Liquid cart markup is server-rendered; reload so the new gift line appears. */
        window.location.reload();
      } else {
        window.setTimeout(refresh, 350);
      }
    } else if (!eligible && giftLine) {
      await fetch(`${root}cart/change.js`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: giftLine.key, quantity: 0 }) });
    }
  }

  function refresh() { return getCart().then(async cart => { await addGiftIfEligible(cart); render(cart); }).catch(error => { console.warn("CB Rewards could not read the Shopify cart", error); }); }
  function open() { lastActiveElement = document.activeElement; panel.setAttribute("aria-hidden", "false"); window.setTimeout(() => dialog.focus(), 0); }
  function close() { panel.setAttribute("aria-hidden", "true"); lastActiveElement?.focus(); }

  icon?.addEventListener("click", open);
  document.querySelectorAll("[data-cb-close-rewards]").forEach(button => button.addEventListener("click", close));
  document.addEventListener("keydown", event => { if (event.key === "Escape") close(); });
  document.addEventListener("cart:updated", refresh);
  document.addEventListener("visibilitychange", () => { if (!document.hidden) refresh(); });
  window.addEventListener("pageshow", refresh);

  /* Catch standard Shopify Ajax cart operations, including add, update, change, and clear. */
  const nativeFetch = window.fetch.bind(window);
  window.fetch = async function (...args) {
    const response = await nativeFetch(...args);
    const requestUrl = typeof args[0] === "string" ? args[0] : args[0]?.url || "";
    if (/\/cart\/(add|change|update|clear)(\.js)?(?:[?#]|$)/.test(requestUrl)) {
      window.setTimeout(refresh, 250);
    }
    return response;
  };

  window.CBRewards = { refresh, open, close };
  refresh();
}());